import Image from "next/image";
import type { ReactNode } from "react";

export type PhotoSceneImage = { src: string; alt: string };

/**
 * A real photo of a person with white cards laid over it (the value
 * sections on the service hubs). Cards use `.cc-wv-card` and land one by one
 * when their demo tab opens (`.cc-demo[data-inview] .cc-demo__view[data-active]`).
 */
export function CcPhotoScene({
  photo,
  variant,
  children,
}: {
  photo: PhotoSceneImage;
  /** Modifier for per-scene photo framing and card placement. */
  variant: string;
  children: ReactNode;
}) {
  return (
    <figure className={`cc-wv-scene cc-wv-scene--${variant}`}>
      <Image
        src={photo.src}
        alt={photo.alt}
        fill
        sizes="(min-width: 1280px) 1200px, 100vw"
        quality={75}
      />
      <span className="cc-wv-scene__shade" aria-hidden="true" />
      <div className="cc-wv-scene__cards" aria-hidden="true">
        {children}
      </div>
    </figure>
  );
}

/** A real tool logo from `/assets/imgs/tools`. */
export function CcToolLogo({ name, size = 16 }: { name: string; size?: number }) {
  return (
    <Image
      src={`/assets/imgs/tools/${name}.svg`}
      alt=""
      width={size}
      height={size}
      unoptimized
    />
  );
}
